import React, { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

function formatNumber(n) {
  return Math.floor(n).toLocaleString("en-IN");
}

export const Counter = ({ target = 0, suffix = "", duration = 2000, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = null;
    let frame;
    const step = (ts) => {
      if (start === null) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(eased * target);
      if (progress < 1) frame = requestAnimationFrame(step);
    };
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [inView, target, duration]);

  return (
    <span ref={ref} className={className}>
      {formatNumber(value)}
      {suffix}
    </span>
  );
};
